import React from "react";
import Navbar from "@/components/landing/Navbar";
import LanguageBanner from "@/components/landing/LanguageBanner";
import Hero from "@/components/landing/Hero";
import Achievements from "@/components/landing/Achievements";
import AboutCharles from "@/components/landing/AboutCharles";
import AboutIsiGroup from "@/components/landing/AboutIsiGroup";
import Services from "@/components/landing/Services";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import { useSiteContent } from "@/context/SiteContentContext";
import { trackPageView, loadGA4 } from "@/lib/analytics";

export default function LandingPage() {
  const content = useSiteContent();
  const gaId = content?.footer?.ga4_measurement_id;

  React.useEffect(() => {
    trackPageView();
  }, []);

  React.useEffect(() => {
    if (gaId) loadGA4(gaId);
  }, [gaId]);

  return (
    <main data-testid="landing-page" className="bg-slate-50 text-slate-900 overflow-x-hidden">
      <LanguageBanner />
      <Navbar />
      <Hero />
      <Achievements />
      <AboutCharles />
      <AboutIsiGroup />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
